import React, { useState } from 'react'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css'
import moment from 'moment'

function InputDateRange(props) {
    var label = moment(props.period.startDate, "YYYY-MM-DD").format('DD/MM/YYYY') + ' - ' + moment(props.period.endDate, "YYYY-MM-DD").format('DD/MM/YYYY')
    if (props.period.startDate === "2019-11-13" && props.period.endDate === moment().format('YYYY-MM-DD')) {
        label = "ทั้งหมด"
    } else if (props.period.startDate === moment().format('YYYY-MM-DD') && props.period.endDate === moment().format('YYYY-MM-DD')) {
        label = "วันนี้"
        // } else if (props.period.startDate === moment().subtract(1, 'days').format('YYYY-MM-DD') && props.period.endDate === moment().subtract(1, 'days').format('YYYY-MM-DD')) {
        //     label = "เมื่อวานนี้"
    } else if (props.period.startDate === moment().subtract(6, 'days').format('YYYY-MM-DD') && props.period.endDate === moment().format('YYYY-MM-DD')) {
        label = "7 วันล่าสุด"
    } else if (props.period.startDate === moment().subtract(29, 'days').format('YYYY-MM-DD') && props.period.endDate === moment().format('YYYY-MM-DD')) {
        label = "30 วันล่าสุด"
    } else if (props.period.startDate === moment().startOf('month').format('YYYY-MM-DD') && props.period.endDate === moment().endOf('month').format('YYYY-MM-DD')) {
        label = "เดือนนี้"
    } else if (props.period.startDate === moment().startOf('year').format('YYYY-MM-DD') && props.period.endDate === moment().endOf('year').format('YYYY-MM-DD')) {
        label = "ปีนี้"
    } else if (props.period.startDate === moment().startOf('year').subtract(1, 'years').format('YYYY-MM-DD') && props.period.endDate === moment().endOf('year').subtract(1, 'years').format('YYYY-MM-DD')) {
        label = "ปีที่แล้ว"
    }

    const [labelDate, setLabelDate] = useState(label)
    const [period, setPeriod] = useState(props.period)

    const handleCallback = (start, end, label) => {
        setLabelDate((label === "กำหนดเอง") ? start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY') : label)
        setPeriod({
            startDate: start.format('YYYY-MM-DD'),
            endDate: end.format('YYYY-MM-DD')
        })
        if (props.onChange !== undefined) props.onChange(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'))
    }

    return (
        <DateRangePicker
            onCallback={handleCallback}
            initialSettings={{
                linkedCalendars: false,
                showDropdowns: true,
                startDate: moment(period.startDate, "YYYY-MM-DD"),
                endDate: moment(period.endDate, "YYYY-MM-DD"),
                minDate: moment(props.minDate, "YYYY-MM-DD"),
                locale: {
                    "format": "DD/MM/YYYY",
                    "separator": " - ",
                    "applyLabel": "ยืนยัน",
                    "cancelLabel": "ยกเลิก",
                    "fromLabel": "ตั้งแต่",
                    "toLabel": "จนถึง",
                    "customRangeLabel": "กำหนดเอง",
                    "weekLabel": "สัปดาห์",
                    "daysOfWeek": ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
                    "monthNames": ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
                    "firstDay": 1
                },
                ranges: (props.allDate ? {
                    'ทั้งหมด': [moment('2019-11-13', "YYYY-MM-DD"), moment()],
                    'วันนี้': [moment(), moment()],
                    // 'เมื่อวานนี้': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    '7 วันล่าสุด': [moment().subtract(6, 'days'), moment()],
                    '30 วันล่าสุด': [moment().subtract(29, 'days'), moment()],
                    'เดือนนี้': [moment().startOf('month'), moment().endOf('month')],
                    'ปีนี้': [moment().startOf('year'), moment().endOf('year')],
                    'ปีที่แล้ว': [moment().startOf('year').subtract(1, 'years'), moment().endOf('year').subtract(1, 'years')]
                } : {
                    'วันนี้': [moment(), moment()],
                    // 'เมื่อวานนี้': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    '7 วันล่าสุด': [moment().subtract(6, 'days'), moment()],
                    '30 วันล่าสุด': [moment().subtract(29, 'days'), moment()],
                    'เดือนนี้': [moment().startOf('month'), moment().endOf('month')],
                    'ปีนี้': [moment().startOf('year'), moment().endOf('year')],
                    'ปีที่แล้ว': [moment().startOf('year').subtract(1, 'years'), moment().endOf('year').subtract(1, 'years')]
                })
            }}>
            <div className="input-group pointer" style={{ pointerEvents: (props.disabled ? "none" : "initial") }}>
                <span className="input-group-text">
                    <i className="bi bi-calendar3"></i>
                </span>
                <input type="text" className={props.className + " pointer"} id={props.id} name={props.name} value={labelDate} onChange={() => null} readOnly={props.disabled} />
            </div>
        </DateRangePicker>
    )
}

InputDateRange.defaultProps = {
    id: "date_range",
    name: "date_range",
    minDate: "2019-11-13",
    period: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    },
    className: "form-control",
    allDate: true,
    disabled: false
}

export default InputDateRange